import { useContext } from 'react';
import { Route, Redirect, useLocation, RouteProps } from 'react-router-dom';
import { ApplicationProvider, appUserContext, authContext } from 'helpers/services';
import { PrivateLayout, CircleLoader } from 'components';


interface IProps extends RouteProps {
    hideLayout?: boolean
}

let PrivateRoute = ({ hideLayout = false, exact, path, component }: IProps) => {
    let location = useLocation();
    let authService = useContext(authContext);
    let userService = useContext(appUserContext);

    return (
        <>
            {authService.isLoading === true && <CircleLoader />}
            {authService.isLoading === false &&
                <>
                    {authService.isAuthenticated === false && <Redirect to={`/account/login?returnUrl=${location.pathname}`} />}
                    {authService.isAuthenticated === true &&
                        <>
                            {userService.isLoading === true && <CircleLoader />}
                            {userService.isLoading === false &&
                                <>
                                    {userService.isAuthorized === false && <Redirect to={'/error403'} />}
                                    {userService.isAuthorized === true &&
                                        <ApplicationProvider>
                                            {hideLayout === true && <Route exact={exact} path={path} component={component} />}
                                            {hideLayout === false &&
                                                <PrivateLayout>
                                                    <Route exact={exact} path={path} component={component} />
                                                </PrivateLayout>
                                            }
                                        </ApplicationProvider>
                                    }
                                </>
                            }
                        </>
                    }
                </>
            }
        </>
    )
}

export default PrivateRoute;